import { memo } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

const WithRecaptchaProvider = ({ children }: { children: React.ReactElement }) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
      scriptProps={{
        defer: true,
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  )
}

export default memo(WithRecaptchaProvider, (old, latest) => {
  return old.children.type.name === latest.children.type.name
})
